import { FiatInput } from 'BreetComponents';
import {
	CURRENCYCONFIG,
	formatCurrencyInputAmount,
	formatNumberWithCommas,
	getNearestValidAmount,
	getWithdrawRules,
} from 'BreetHelpers';
import { useCryptoFormAmount, useUsdWithdrawRequestContext, useUserWalletApi } from 'BreetHooks';
import { selectMeta, useAppSelector } from 'BreetRedux';
import { memo, useCallback, useEffect } from 'react';

const FormAmountComponent = () => {
	const { formDataContextProps } = useUsdWithdrawRequestContext();

	const meta = useAppSelector(selectMeta);

	const userWalletProps = useUserWalletApi(CURRENCYCONFIG.USD.code);

	const { withdrawalMaxAmount, withdrawalMinAmount } = getWithdrawRules(meta?.settings, CURRENCYCONFIG.USD.code);

	const { handleAmountChange, inputMessage, setInputMessage, commitAmount } = useCryptoFormAmount({
		withdrawalMaxAmount,
		withdrawalMinAmount,
		formDataContextProps,
		userWalletProps,
		currencySymbol: CURRENCYCONFIG.USD.symbol,
		currencyCode: CURRENCYCONFIG.USD.code,
	});

	const {
		hookFormProps: {
			watch,
			formState: { errors },
		},
	} = formDataContextProps;

	const handleMaxClick = useCallback(() => {
		const walletBalance = userWalletProps.walletBalance;

		const effectiveMaxAmount = withdrawalMaxAmount > 0 ? withdrawalMaxAmount : walletBalance;

		let amount = Math.min(walletBalance, effectiveMaxAmount);

		if (inputMessage) {
			setInputMessage('');
		}

		if (walletBalance > effectiveMaxAmount) {
			setInputMessage(`Maximum withdrawal per transaction is $ ${formatNumberWithCommas(effectiveMaxAmount)}`);
		}

		amount = getNearestValidAmount(amount, false);

		commitAmount(amount.toString());
	}, [commitAmount, inputMessage, setInputMessage, userWalletProps.walletBalance, withdrawalMaxAmount]);

	useEffect(() => {
		const currentAmount = watch('amount');

		if (currentAmount !== '0') {
			commitAmount(currentAmount);
		}
	}, [watch, commitAmount]);

	return (
		<FiatInput.WithdrawRequest
			label='Enter USD Amount'
			currencyCode='USD'
			handleMaxClick={handleMaxClick}
			onChange={handleAmountChange}
			errorMessage={errors.amount?.message}
			message={inputMessage}
			value={formatCurrencyInputAmount(watch('amount'), 'USD')}
		/>
	);
};

const FormAmount = memo(FormAmountComponent);

export default FormAmount;
